
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.35003 19.65L8.14003 17.86C8.46003 17.54 8.24003 17 7.79003 17H7.00003V5C7.00003 4.45 6.55003 4 6.00003 4C5.45003 4 5.00003 4.45 5.00003 5V17H4.21003C3.76003 17 3.54003 17.54 3.86003 17.85L5.65003 19.64C5.84003 19.84 6.16003 19.84 6.35003 19.65ZM12.2 8.5V13.5L10.6 14.16C10.24 14.31 10 14.66 10 15.05C10 15.74 10.71 16.2 11.34 15.93L20.31 12.05C20.73 11.87 21 11.46 21 11C21 10.54 20.73 10.13 20.31 9.95L11.34 6.07C10.71 5.8 10 6.27 10 6.96C10 7.35 10.24 7.7 10.6 7.85L12.2 8.5ZM19.02 11L14 12.87V9.13L19.02 11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-text-rotation-down`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTextRotationDown

    ```js
    <b-new-b-icon-text-rotation-down />
    ```
</docs>


